import * as React from "react";
import {lazyInject} from "@athena-portal/core";
import {Overlay} from "@athena-portal/components";
import {Types, IFalconPropositionEngine} from "@falcon/services";
import {Redirect} from "react-router";
import {RetrieveQuoteFailureMessagePage} from "./RetrieveQuoteFailureMessagePage";
import {PluginTemplates} from "@falcon/plugin-falcon-journey";

interface IState {
    interaction?: any;
    match?: any;
    loadingInteraction?: boolean;
    tokenExpired?: boolean;
}

export class RetrieveQuoteAndProceedPage extends React.Component<IState, IState> {

    @lazyInject(Types.FalconPropositionEngine)
    private propositionEngine: IFalconPropositionEngine;

    private pluginTemplates = new PluginTemplates();

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Quote retrieve and proceed");

        this.setState({loadingInteraction: true});

        const token = this.props.match.params.token;

        this.propositionEngine.fetchInteractionByToken(token).subscribe(
            (response: any) => {
                const interaction = response.response;
                this.setState({interaction, loadingInteraction: false});
            },
            (error: any) => {
                if (error.response && error.response.reason) {
                    this.setState({tokenExpired: error.response.reason === 'exp'});
                }
                this.setState({loadingInteraction: false});
            });
    }

    public render() {
        if (this.state.loadingInteraction) {
            return <Overlay show={true}/>
        }
        const {interaction} = this.state;
        const token = this.props.match.params.token;
        const decode = (str: string): string => Buffer.from(str, 'base64').toString('binary');
        const payload: string = token.split('.')[1];
        const product: string = JSON.parse(decode(payload)).product;

        if (interaction && interaction._id && product === "PropositionWolfMotorInsurance") {
            return (
                <Redirect
                    to={`/journey/show/product/AnnualMotorInsurance/process/nb/summary/${interaction._id}`}/>
            );
        } else  if (interaction && interaction._id && product === "AnnualHomeInsurance") {
            return (
                <Redirect
                    to={`/journey/show/product/AnnualHomeInsurance/process/nb/quote/${interaction._id}`}/>
            );
        } else  if (interaction && interaction._id) {
            return (
                <Redirect
                    to={`/journey/show/product/MotorInsurance/process/nb/gdprPage/${interaction._id}`}/>
            );
        } else {
            let interactionId: string = "";
            if (this.state.tokenExpired) {
                interactionId = JSON.parse(decode(payload)).interactionId;
            }

            if (interactionId) {
                return (
                    <Redirect to={`/retrieveQuote?quote_id=${interactionId}`}/>
                );
            } else {
                return (
                    <RetrieveQuoteFailureMessagePage message="Quote not found, please enter details again..."/>
                );
            }

        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/quote/RetrieveQuoteAndProceedPage.tsx